import React from "react";
import SectionShell from "./SectionShell";

export default function MasqueradeSection() {
  return (
    <SectionShell
      id="alarcosbal"
      testId="masquerade-section"
      eyebrow="A mátrixban"
      titleStart="A mátrixban"
      titleAccent="álarcosbál"
      titleEnd=" az élet"
      tinted
    >
      {/* Opening quote — Szász-Tóth Enikő, verbatim */}
      <div className="my-6 md:my-8 text-center">
        <p className="font-serif-display italic text-[22px] sm:text-[26px] md:text-[30px] leading-[1.45] text-graphite max-w-xl mx-auto">
          „A mátrixban álarcos bál az élet. A valódi esszencia valahol út közben
          elveszett. Vesd le a{" "}
          <span className="text-gold">szerepeket</span>, s az út során valódi önmagad
          megleled. A tiszta kapcsolódásokat csakis a{" "}
          <span className="text-gold">szív térből</span> indítva teremtheted."
        </p>
        <p className="mt-5 text-[12px] tracking-[0.3em] uppercase text-muted-warm font-body">
          — Szász-Tóth Enikő
        </p>
      </div>

      {/* Body — flowing, justified, book-like */}
      <p>
        Életünk során szinte észrevétlenül kezdünk szerepeket felvenni. Eleinte azért,
        hogy biztonságban legyünk, szeressenek, elfogadjanak és megfeleljünk azoknak az
        elvárásoknak, amit a család, a környezet vagy a társadalom támaszt felénk.
        Lassan kialakulnak azok az identitások, amelyek egykor talán valóban segítettek
        bennünket.
      </p>

      {/* Roles — premium intro-box, separate lines, finom rhythm */}
      <aside
        data-testid="masquerade-roles"
        className="my-8 md:my-10 mx-auto max-w-xl bg-warm border border-hairline px-7 md:px-10 py-7 md:py-8"
      >
        <p className="font-serif-display italic text-graphite text-[18px] md:text-[20px] leading-[1.9] text-center">
          A jó gyerek.
          <br />
          Az erős.
          <br />
          A mindig segítő.
          <br />
          A megfelelni akaró.
          <br />
          A sikeres.
          <br />
          A megmentő.
          <br />
          Aki mindig mosolyog.
          <br />
          Aki soha nem kér segítséget.
        </p>
      </aside>

      <p>
        Eleinte ezek a szerepek valóban szolgálnak bennünket. Később azonban már nem mi
        alakítjuk őket, hanem ők alakítják az életünket. Egyszer csak azon kapjuk magunkat,
        hogy már nem is tudjuk, hol végződik a szerep… és hol kezdődünk mi. A legtöbb ember
        nem tudatosan él szerepekben. Egyszerűen annyira hozzászokott a saját történeteihez,
        hogy idővel már önmagának hiszi őket. Erről a következő blokkban írok. A konzultációk
        során ezért nem egy újabb szerepet keresünk. Nem szeretnélek egy újabb címkével
        gazdagítani, vagy megmondani, hogy ki vagy. Sokkal inkább együtt ránézünk azokra a
        történetekre, amelyek talán már régóta nem szolgálnak téged. Azokra a hiedelmekre,
        azonosulásokra, belső mondatokra, amelyeket eddig valóságnak hittél.
      </p>

      {/* Closing emphasis — champagne/gold highlight, same rhythm as other pull-quotes */}
      <div className="my-8 md:my-10 text-center">
        <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-graphite max-w-xl mx-auto">
          A valódi szabadság nem akkor kezdődik, amikor valaki mássá válsz.
        </p>
        <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-gold max-w-xl mx-auto mt-4">
          Hanem amikor végre nem kell többé szerepet játszanod.
        </p>
      </div>
    </SectionShell>
  );
}
